import React from 'react'
import {Route, Routes as Switch } from 'react-router-dom'
import {Commande} from '../pages/commande'
import {Home} from '../pages/home'
import {MenuContent} from '../pages/menu'
import {User} from '../pages/user'
import {Settings} from '../pages/settings'
import {Login} from '../pages/auth/login'
import RouteMiddleware from '../middleware/route.middleware'
import {AuthLayout} from '../pages/auth/auth.layout'
import { NotFound } from '../pages/notfound'
import { Boisson } from '../pages/boisson'
import UserInfos from '../pages/user.infos'
import { useAuth } from '../middleware/auth.middleware'
import { HomeGymSpa } from '../pages/GYM_SPA/home.gymspa'
import Constants from '../tools/constants.tools'
import { TermineGYMSPA } from '../pages/GYM_SPA/termine'
import { RejeteGYMSPA } from '../pages/GYM_SPA/rejete'
import { AttenteGYMSPA } from '../pages/GYM_SPA/attente'
import { EnCoursGYMSPA } from '../pages/GYM_SPA/en_cours'

export const Routes = () => {
  const {role} = useAuth();
  return (
    <Switch>

      {/* auth routes  */}
      
      <Route path="/" element={<AuthLayout />} >
        <Route index element={<Login />} />
        <Route path='login' element={<Login />} />
      </Route>

      {
        role === Constants.GYM || role === Constants.SPA ? (
          <Route path="/dashboard" element={<RouteMiddleware />}>
            <Route index element={<HomeGymSpa />} />
            <Route path='home' element={<HomeGymSpa />} />
            <Route path='termine' element={<TermineGYMSPA />} />
            <Route path='rejete' element={<RejeteGYMSPA />} />
            <Route path='attente' element={<AttenteGYMSPA />} />
            <Route path='en_cours' element={<EnCoursGYMSPA />} />
          </Route>
        ) : (
          <Route path="/dashboard" element={<RouteMiddleware />} >
            <Route index element={<Home />} />
            <Route path='home' element={<Home />} />
            { role !== 'rh' && <Route path='menu' element={<MenuContent />} />}
            { role !== 'rh' && <Route path='boisson' element={<Boisson />}  />}
            { role !== 'restaurant' && <Route path='user' element={<User />} />}
            <Route path='commande' element={<Commande />} />
            <Route path='user/:id' element={<UserInfos />} />
            <Route path='settings' element={<Settings />} />
          </Route>
        )
      }
      <Route path="*" element={<NotFound />} />

    </Switch>
  )
}